"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_WIDTH = exports.MAX_DPR = exports.createImgixClient = void 0;
var js_core_1 = __importDefault(require("@imgix/js-core"));
var constants_1 = require("../../common/constants");
var createImgixClient = function (_a) {
    var libraryParam = _a.libraryParam, rest = __rest(_a, ["libraryParam"]);
    var client = new js_core_1.default(__assign(__assign({}, rest), { includeLibraryParam: false }));
    // This is not a public API, so it is not included in the type definitions for ImgixClient
    if (libraryParam != null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        client.settings.libraryParam = libraryParam + "-" + constants_1.VERSION;
    }
    return client;
};
exports.createImgixClient = createImgixClient;
exports.MAX_DPR = 5;
exports.MAX_WIDTH = 8192;
//# sourceMappingURL=common.js.map